export default __webpack_public_path__ + "static/media/login-image.d454b9e7.png";